import { FontAwesomeIcon, Tag } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface ScoreTagSize {
  md: string;
  lg: string;
  xl: string;
}

const scoreTagSizeClasses: Record<keyof ScoreTagSize, string> = {
  md: "min-w-9 h-6 text-sm",
  lg: "min-w-12 h-8 text-xl",
  xl: "min-w-16 h-16 text-2xl rounded-sm shadow-md",
};

export const ScoreTag = ({
  score,
  onClick,
  variant = "primary",
  size = "md",
  isModified = false,
  emptyText,
  isPending = false,
}: {
  score: number | null | undefined;
  onClick?: () => void;
  variant?: "primary" | "secondary";
  size?: keyof ScoreTagSize;
  isModified?: boolean;
  emptyText?: string;
  isPending?: boolean;
}) => {
  const sizeClass = scoreTagSizeClasses[size];
  const hasScore = score !== null && score !== undefined;

  if (emptyText) {
    return (
      <Tag className={twMerge(sizeClass)} variant={"secondary"} onClick={onClick}>
        {emptyText}
      </Tag>
    );
  }

  const renderContent = () => {
    return hasScore ? (
      score.toFixed(1)
    ) : isPending ? (
      <FontAwesomeIcon icon="fa-light fa-hourglass text-secondary" />
    ) : (
      (emptyText ?? "-")
    );
  };

  return (
    <Tag
      className={twMerge(
        "tabular-nums lining-nums",
        sizeClass,
        !hasScore && isPending ? "bg-dark/5 border-dark/0" : ""
      )}
      variant={score ? variant : "secondary"}
      onClick={onClick}
    >
      {renderContent()}
      {isModified && <span>*</span>}
    </Tag>
  );
};
